<template>
  <div>
    <!-- 소속 사업장은 **오더엔 내부 관리자**만 고른다 — `POST /store/mng` 가 이 값을 그대로 쓴다 -->
    <el-row v-if="isInternalAdmin">
      <el-col :md="12">
        <el-form-item :label="$t('소속 사업장')" required>
          <el-select
            v-model="inputForm.cust.custCd"
            filterable
            remote
            default-first-option
            style="width: 100%"
            :placeholder="$t('사업장명을 입력 하여 검색')"
            :remote-method="custSearch">
            <el-option
              v-for="item in cust"
              :key="item.custCd"
              :label="item.custCd == null ? '최상위 사업장' : item.custId + ' ' + item.custNm"
              :value="item.custCd"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :md="inputForm.lans.length > 0 ? 16 : 24">
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('매장명')" :error="formError.storeNm" required>
              <el-input v-model="inputForm.storeNm" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('디폴트 언어')" :error="formError['defaultLan.id']" required>
              <lan-combo :data="lans" :model="inputForm.defaultLan.id" @change="defaultLanChange"></lan-combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('전화번호')" :error="formError.tel" required>
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('언어 추가')">
              <lans-combo
                :data="lans"
                :model="inputForm.lans"
                :disable_id="inputForm.defaultLan.id"
                @change="lansChange"></lans-combo>
            </el-form-item>
          </el-col>

          <el-col :md="12">
            <el-form-item :label="$t('매장 유형')" :error="formError.storeTps">
              <mcombo :data="storeTp" :model="inputForm.storeTps" @change="inputForm.storeTps = $event"></mcombo>
            </el-form-item>
          </el-col>

          <el-col :md="12">
            <el-form-item :label="$t('웹 결제 구분')" :error="formError.payTps" required>
              <mcode-combo :data="payTp" :model="inputForm.payTps" @change="inputForm.payTps = $event"></mcode-combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('웹 판매 방식')" :error="formError.webSalesTps">
              <mcode-combo
                :data="webSalesTp"
                :model="inputForm.webSalesTps"
                @change="inputForm.webSalesTps = $event"></mcode-combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('키오스크 판매 방식')" :error="formError.kioskSalesTps" required>
              <mcode-combo
                :data="appSalesTp"
                :model="inputForm.kioskSalesTps"
                @change="inputForm.kioskSalesTps = $event"></mcode-combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('매장 주소')" :error="formError.storeAddr" required>
              <el-input v-model="inputForm.storeAddr" maxlength="250" show-word-limit readonly>
                <el-button slot="append" @click="selectStoreAddress()">{{ $t('주소 조회') }}</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('매장 상세 주소')" :error="formError.storeAddrDtl" required>
              <el-input
                ref="store_addr_dtl"
                v-model="inputForm.storeAddrDtl"
                maxlength="100"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('GPS 경도')" :error="formError.gpsLng" required>
              <el-input v-model="inputForm.gpsLng" style="width: 180px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('GPS 위도')" :error="formError.gpsLat" required>
              <el-input v-model="inputForm.gpsLat" style="width: 180px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item :label="$t('설명')" :error="formError.storeDesc">
              <el-input v-model="inputForm.storeDesc" type="textarea" maxlength="250" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item :label="$t('AI 키오스크 지시어')" :error="formError.aiKioskInstructions">
              <el-input
                v-model="inputForm.aiKioskInstructions"
                type="textarea"
                maxlength="250"
                show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col v-if="!checkAuthId('storeMng')" :lg="12">
            <el-form-item :label="$t('가입일')" :error="formError.startDt" required>
              <el-date-picker
                v-model="inputForm.startDt"
                :disabled="locked('startDt')"
                type="date"
                :placeholder="$t('가입일')"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="!checkAuthId('storeMng')" :lg="12">
            <el-form-item :label="$t('탈퇴일')" :error="formError.endDt">
              <el-date-picker
                v-model="inputForm.endDt"
                :disabled="locked('endDt')"
                aria-autocomplete="none"
                type="date"
                :placeholder="$t('탈퇴일')"
                value-format="yyyy-MM-dd"
                name="탈퇴일"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('주문 통지')">
              <el-switch v-model="inputForm.orderNoti"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>

      <el-col :md="8" v-if="inputForm.lans.length > 0" style="padding-left: 40px">
        <el-tabs v-model="activiTab">
          <el-tab-pane
            v-for="(item, index) in inputForm.storeInfos"
            :key="item.storeInfoCd"
            :label="item.lanTp.nm"
            :name="String(item.storeInfoCd)">
            <el-form-item
              :label="$t('매장명')"
              :label-width="$device.mobile ? `` : `120px`"
              :error="formError['storeInfos[' + index + '].storeInfoNm']"
              required>
              <el-input
                v-model="inputForm.storeInfos[index].storeInfoNm"
                maxlength="50"
                clearable
                show-word-limit></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('매장 주소')"
              :label-width="$device.mobile ? `` : `120px`"
              :error="formError['storeInfos[' + index + '].storeInfoAddr']"
              required>
              <el-input
                v-model="inputForm.storeInfos[index].storeInfoAddr"
                maxlength="250"
                clearable
                show-word-limit></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('매장 상세 주소')"
              :label-width="$device.mobile ? `` : `120px`"
              :error="formError['storeInfos[' + index + '].storeInfoAddrDtl']"
              required>
              <el-input
                v-model="inputForm.storeInfos[index].storeInfoAddrDtl"
                maxlength="100"
                clearable
                show-word-limit></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('매장 설명')"
              :label-width="$device.mobile ? `` : `120px`"
              :error="formError['storeInfos[' + index + '].storeInfoDesc']"
              required>
              <el-input
                v-model="inputForm.storeInfos[index].storeInfoDesc"
                maxlength="250"
                clearable
                show-word-limit></el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="24">
        <el-form-item :label="$t('매장 메인 이미지')" :error="formError['storeImgFile']" required>
          <div class="image-upload-wrap">
            <el-upload
              action=""
              class="avatar-uploader"
              accept="image/*"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="(file) => uploadImage('storeImgFile', file)">
              <fallback-image
                native
                v-if="hasImage('storeImg', 'storeImgFile')"
                :src="this.resolvImage(inputForm.storeImgFile)"
                class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">{{ $t('400x300 픽셀 이미지만 업로드 가능합니다.') }}</div>
            </el-upload>
            <el-button
              v-if="hasImage('storeImg', 'storeImgFile')"
              class="image-delete-btn"
              type="danger"
              icon="el-icon-delete"
              size="mini"
              circle
              @click="removeImage('storeImg', 'storeImgFile')"></el-button>
          </div>
        </el-form-item>
      </el-col>

      <el-col :md="24">
        <el-form-item :label="$t('매장 이미지')">
          <div v-for="n in 5" :key="n" style="float: left; margin-right: 5px">
            <div class="image-upload-wrap">
              <el-upload
                action=""
                class="avatar-uploader"
                accept="image/*"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="(file) => uploadImage('storeImgFile' + n, file)">
                <fallback-image
                  native
                  v-if="hasImage('storeImg' + n, 'storeImgFile' + n)"
                  :src="resolvImage(inputForm['storeImgFile' + n])"
                  class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button
                v-if="hasImage('storeImg' + n, 'storeImgFile' + n)"
                class="image-delete-btn"
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                @click="removeImage('storeImg' + n, 'storeImgFile' + n)"></el-button>
            </div>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { fileRemoval, hasStoredImage } from '@/utils/storedFile'
import { util } from '@/mixins/utilMixin'
import { mainVueAxios } from '@/plugins/http'
import { adminRoleMixin } from '@/mixins/adminRoleMixin'
import { pickAddress } from '@/utils/addressPicker'
import { resolveImage } from '@/utils/resolveImage'
import { isStoreFieldLocked } from '@/utils/storeOps'
import { readonly } from 'vue'

export default {
  mixins: [adminRoleMixin],
  props: ['value', 'formError', 'custSearch', 'cust'],
  data() {
    return {
      activiTab: '',

      lans: [],
      payTp: [],
      // 매장 유형(업종) — 정본은 서버 sys_code STORE_TP(파트너 API 업종 코드표와 같은 표). 화면에 목록을 두지 않는다
      storeTp: [],
      filterTp: [],
      webSalesTp: [],
      appSalesTp: [],
    }
  },
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
  watch: {
    'inputForm.storeInfos': {
      handler: function (val) {
        if (this.activiTab !== '') return
        if (val.length < 1) return

        const key = val[0].storeInfoCd

        if (!key) return

        this.activiTab = String(key)
      },
      immediate: true,
    },
    formError: {
      handler: function (newVal) {
        const fn = () => {
          var i = 100

          for (let val in newVal) {
            if (val.indexOf('storeInfos') > -1) {
              if ('' != newVal[val]) {
                if (i > val.replace(/[^0-9]*/g, '')) {
                  i = parseInt(val.replace(/[^0-9]*/g, ''))
                }
              }
            }
          }

          if (100 != i) {
            this.activiTab = String(this.inputForm.storeInfos[i].storeInfoCd)
          }
        }

        // 기존 코드와 같은 방식, http error 처리와 re render 관련 연관 있어보입니다.
        setTimeout(() => {
          fn()
        }, 500)
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.initLan()
    this.initPayTp()
    this.initStoreTp()
    this.initFilterTp()
    this.initSalesTp()
  },
  methods: {
    resolvImage: resolveImage,

    /** 대행 계정이 바꾸지 못하는 칸인가(가입일·탈퇴일) — 읽기 전용. 판정은 `utils/storeOps` 한 곳이다 */
    locked(key) {
      return isStoreFieldLocked(this.inputForm, key)
    },

    /** 그릴 이미지가 있는가 — 판정은 `utils/storedFile` 한 곳 */
    hasImage(imgKey, fileKey) {
      return hasStoredImage(this.inputForm, imgKey, fileKey)
    },
    /** 이미지 삭제 — 파일 칸에 지움 표시(`utils/storedFile.fileRemoval`, 빈 값은 서버가 「유지」로 읽는다) */
    removeImage(imgKey, fileKey) {
      Object.assign(this.inputForm, fileRemoval(imgKey, fileKey))
    },
    uploadImage(key, file) {
      util.imgToBase64(URL.createObjectURL(file.raw), file.raw.type, (data, img) => {
        if (400 != img.width || 300 != img.height) {
          this.$message({ type: 'warning', message: this.$t('400x300 픽셀 이미지만 업로드 가능합니다.') })
        } else {
          this.inputForm[key] = data
        }
      })
    },

    defaultLanChange: function (e) {
      this.inputForm.defaultLan.id = e

      // 디폴트 언어 선택 하였으면 지우기
      for (var i = 0, len = this.inputForm.lans.length; i < len; i++) {
        if (this.inputForm.defaultLan.id == this.inputForm.lans[i].id) {
          this.inputForm.lans.splice(i, 1)
          this.lansChange(this.inputForm.lans)
          break
        }
      }
    },
    lansChange: function (e) {
      this.inputForm.lans = e

      var tmpStoreInfos = this.inputForm.storeInfos

      this.inputForm.storeInfos = []

      // 없는거 추가
      for (var i = 0, len = e.length; i < len; i++) {
        var isExist = false

        for (var j = 0, jlen = tmpStoreInfos.length; j < jlen; j++) {
          if (e[i].id == tmpStoreInfos[j].lanTp.id) {
            isExist = true

            this.$emit('form-error-update', {
              key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoNm',
              value: '',
            })
            this.$emit('form-error-update', {
              key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoAddr',
              value: '',
            })
            this.$emit('form-error-update', {
              key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoAddrDtl',
              value: '',
            })
            this.$emit('form-error-update', {
              key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoDesc',
              value: '',
            })

            this.inputForm.storeInfos.push(tmpStoreInfos[j])

            this.activiTab = String(tmpStoreInfos[j].storeInfoCd)
            continue
          }
        }

        if (!isExist) {
          this.$emit('form-error-update', {
            key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoNm',
            value: '',
          })
          this.$emit('form-error-update', {
            key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoAddr',
            value: '',
          })
          this.$emit('form-error-update', {
            key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoAddrDtl',
            value: '',
          })
          this.$emit('form-error-update', {
            key: 'storeInfos[' + this.inputForm.storeInfos.length + '].storeInfoDesc',
            value: '',
          })

          this.inputForm.storeInfos.push({
            lanTp: e[i],
            storeInfoNm: '',
            storeInfoAddr: '',
            storeInfoAddrDtl: '',
            storeInfoDesc: '',
          })

          this.activiTab = e[i].id
        }
      }
    },
    initLan: function () {
      mainVueAxios.search(
        '/language',
        null,
        function (result) {
          this.lans = result
        }.bind(this),
        false
      )
    },
    // 매장 유형(업종) 코드표 — mcombo 는 {label,value} 를 받고 storeTps 는 코드 문자열 배열이라 val 로 매핑한다.
    // 서버 코드표가 정본이다(하드코딩 폴백 없음). 배포 게이트: 리얼·test(리얼 DB 공유)에 이 화면을 내기 전에 appserver
    // `sql/db_changes_2026-09-11_partner-api.sql` §3(STORE_TP 이름 정정·SC09/SC10 추가)을 선적용하고 코드 캐시(`code`)를 비운다 —
    // 옛 리얼 표(SC01=카페-디저트 …)가 남은 채 화면이 먼저 나가면 기존 매장의 업종 라벨이 뒤바뀌어 보이고 저장 시 다른 뜻으로 저장된다.
    initStoreTp: function () {
      mainVueAxios.search(
        '/code/getCode/STORE_TP',
        null,
        (result) => {
          this.storeTp = (result || []).map((item) => ({ label: item.nmLan || item.nm, value: item.val }))
        },
        false
      )
    },
    initPayTp: function () {
      mainVueAxios.search(
        '/code/getCode/WEB_PAY_TP',
        null,
        (result) => {
          const seen = new Set()
          this.payTp = result.filter((item) => {
            const duplicate = seen.has(item.cd)
            seen.add(item.cd)
            return !duplicate
          })
        },
        false
      )
    },
    initFilterTp: function () {
      mainVueAxios.search(
        '/code/getCode/FILTER_TP',
        null,
        function (result) {
          this.filterTp = result
        }.bind(this)
      )
    },
    initSalesTp: function () {
      mainVueAxios.search(
        '/code/getCode/SALES_TP',
        null,
        (result) => {
          const webSeen = new Set()
          const appSeen = new Set()
          this.webSalesTp = []
          this.appSalesTp = []

          for (const item of result) {
            if (item.ref1 === 'web' && !webSeen.has(item.cd)) {
              webSeen.add(item.cd)
              this.webSalesTp.push(item)
            }
            if (item.ref2 === 'app' && !appSeen.has(item.cd)) {
              appSeen.add(item.cd)
              this.appSalesTp.push(item)
            }
          }
        },
        false
      )
    },

    /**
     * **다른 질문이라 남는다** — 여기 남은 용도는 `!checkAuthId('storeMng')`(가입일·탈퇴일 칸) 하나이고,
     * 그것은 「오더엔 내부 관리자인가」가 아니라 「매장 관리자인가」다. 내부 역할 축은 [isInternalAdmin] 이
     * `utils/adminRole` 한 곳에 묻는다.
     */
    checkAuthId(authId) {
      return this.$store.getters['auth/authId'] === authId
    },

    /**
     * 매장 주소 선택 — 위젯·지오코더는 `utils/addressPicker` 한 곳이 만진다(종전 `initDaum` 다섯 사본을 접었다).
     *
     * 채우는 값과 포커스 이동은 종전 그대로다. **법정동 코드는 화면이 보내지 않는다**(결정 35): 매장의
     * `bjd_cd` 는 서버 배치가 카카오로 확인해 채우는 값이고 서버도 요청의 `bjdCd` 를 받지 않는다(읽기
     * 전용). 주소를 바꾸면 서버가 옛 코드를 비우고 그날 밤 배치가 새 주소를 다시 묻는다.
     */
    selectStoreAddress: async function () {
      let picked = null
      try {
        picked = await pickAddress({ geocode: true })
      } catch (error) {
        this.$message({ type: 'error', message: error.message })

        return
      }
      if (!picked) return

      this.inputForm.storeAddr = picked.address
      // 좌표를 얻었을 때만 GPS 를 채우고 상세주소로 옮긴다 — 종전 동작 그대로다
      if (picked.lat === null || picked.lng === null) return

      this.inputForm.gpsLng = picked.lng
      this.inputForm.gpsLat = picked.lat
      this.$refs.store_addr_dtl.focus()
    },
  },
}
</script>

<style scoped>
.el-col {
  padding: 4px;
}

.image-upload-wrap {
  position: relative;
  display: inline-block;
}

.image-delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 1;
}
</style>
